import React from 'react';
import { AtendimentoButton } from '../atendimentoButton';
import logoPlataforma from "../../assets/img/logo_plataforma_porto.png";
import { infoFooter } from './FooterData';
import './Footer.css';

const Footer = () => (
  <footer className="footer footer-margin footer-padding">
    <AtendimentoButton />

    <div className="links-container">
      <nav className="left-nav-container">
        {infoFooter.map(data => (
          <a
            className={data.innerClassName}
            data-gtm-type="click"
            data-gtm-clicktype="link"
            data-gtm-name={data.name}
            href={data.href}
            target={data.target}
            style={data.style}
          >
            {data.info}
          </a>
        ))}
      </nav>
      <nav class="pull-right out-margin">
        <img alt="Logo Porto" src={logoPlataforma} />
      </nav>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx